(() => {
  if (window.__SIZECHART_LOADED__) return;
  window.__SIZECHART_LOADED__ = true;

  const HEADER_COLORS = { women: "#A56380", men: "#0B4D27" };

  function detectGender() {
    const selectElements = {
      'template-product': document.querySelector('h1'),
      'template-page': document.querySelector('.product-form h1'),
    };

    const key = ['template-product', 'template-page'].find(cls => document.body.classList.contains(cls));
    const selectedElement = key ? selectElements[key] : null;

    if (selectedElement) {
      let defaultDialog = document.querySelector('dialog.gp-dialog');
      if(defaultDialog){
        //defaultDialog.remove();
        //defaultDialog.style.display = 'none';
        //defaultDialog.parentNode.parentNode.remove();
        //defaultDialog.parentNode.parentNode.classList.add('gempages-sizechart');
        if(!document.querySelector('product-form h1').innerText.includes('Earthing & Grounding Mat for Bed') && !document.querySelector('product-form h1').innerText.includes('Grounding Mats Bundle')) {
          let defaultDialog = document.querySelector('dialog.gp-dialog');
          defaultDialog.style.display = 'none';
          defaultDialog.parentNode.parentNode.remove();
        }
      }
      const arrayTitle = selectedElement.innerText.toLowerCase().split(' ');
      const keyword = arrayTitle.find(word => word.includes('women') || word.includes('men')) || null;
      return keyword;
    }
  }

  const SIZE_CHART_DATA = window.SIZECHART_DATA || {
    women: { rows: [] },
    men: { rows: [] },
  };

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const round = (n, d = 1) => (Number.isFinite(n) ? Number(n.toFixed(d)) : n);
  const toCM = (v) => round(v * 2.54, 1);
  const isNum = (v) => /^\s*-?\d+(\.\d+)?\s*$/.test(v);
  const clean = (v) =>
    typeof v === "string" ? v.replace(/["']/g, "").trim() : v;
function buildTable(gender, unit) {
  const rows = SIZE_CHART_DATA[gender]?.rows || [];
  if (!rows.length) return { head: [], body: [] };

  // 1) Cabecera: Heel-toe (INCH/CM) + valores convertidos si toca
  const headRow = rows[0];
  const headLabel = unit === "cm" ? (headRow.label_cm || headRow.label_in) : headRow.label_in;
  const head = [
    headLabel,
    ...headRow.values.map((val) => {
      const c = clean(val);
      if (!isNum(c)) return c;
      const num = parseFloat(c);
      return unit === "cm" ? toCM(num) + 'cm' : `${num}"`;
    }),
  ];

  const SKIP_CONVERT = /^(US Size|EU Size)$/i;

  const body = rows.slice(1).map((r) => {
    const label = unit === "cm" ? (r.label_cm || r.label_in) : r.label_in;

    if (SKIP_CONVERT.test(r.label_in)) {
      return [label, ...r.values.map(clean)];
    }
    return [
      label,
      ...r.values.map((cell) => {
        const c = clean(cell);
        if (!isNum(c)) return c; 
        const num = parseFloat(c);
        return unit === "cm" ? toCM(num) + 'cm' : `${num}"`;
      }),
    ];
  });

  return { head, body };
}

  function renderTable(wrapper, { head, body }) {
    wrapper.innerHTML = "";
    if (!head.length)
      return (wrapper.innerHTML =
        "<p class='size-chart-empty'>No size chart available</p>");
    const table = document.createElement("table");
    table.className = "size-chart-table";
    const thead = document.createElement("thead");
    const trh = document.createElement("tr");
    head.forEach((h) => {
      const th = document.createElement("th");
      th.textContent = h;
      trh.appendChild(th);
    });
    thead.appendChild(trh);
    const tbody = document.createElement("tbody");
    console.log({ body })
    console.log({ head })
    body.forEach((row) => {
      const tr = document.createElement("tr");
      row.forEach((cell, i) => {
        const td = document.createElement("td");
        td.textContent = cell;
        if (i === 0) td.className = "is-label";
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    table.append(thead, tbody);
    wrapper.appendChild(table);
  }

  const modal = $("#sizeChartModal");
  const wrapper = $(".table-wrapper", modal);
  let currentGender = detectGender();
  let currentUnit = "in";
  //console.log(currentGender)

  function setHeaderColor() {
    modal.style.setProperty(
      "--sg-header-bg",
      HEADER_COLORS[currentGender] || "#333"
    );
  }

  function openModal() {
    console.log(document.querySelector('dialog.gp-dialog'))
    let defaultDialog = document.querySelector('dialog.gp-dialog');
    if(defaultDialog){
      //defaultDialog.remove();
      //defaultDialog.style.display = 'none';
      //defaultDialog.parentNode.parentNode.remove();
    }
    setHeaderColor();
    const title = $("#sizeChartTitle", modal);
    if (title)
      title.textContent =
        currentGender === "men" ? "Men's Sizing" : "Women's Sizing";
    renderTable(wrapper, buildTable(currentGender, currentUnit));
    modal.setAttribute("aria-hidden", "false");
    initScrollbar(wrapper);
  }

  function closeModal() {
    modal?.setAttribute("aria-hidden", "true");
    history.pushState("", document.title, window.location.pathname + window.location.search);

  }

  $(".size-chart-close-mobile", modal)?.addEventListener("click", closeModal);
  $(".size-chart-close-desktop", modal)?.addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  $$(".unit-button", modal).forEach((btn) => {
    btn.addEventListener("click", () => {
      currentUnit = btn.dataset.unit === "cm" ? "cm" : "in";
      $$(".unit-button", modal).forEach((b) =>
        b.classList.toggle("active", b.dataset.unit === currentUnit)
      );
      renderTable(wrapper, buildTable(currentGender, currentUnit));
      initScrollbar(wrapper);
    });
  });

  function tryOpenSizeChart(triggerSource = "manual") {
    
    const gender = detectGender();

    if (!gender) {
      console.warn(
        `[SizeChart] Modal blocked - not eligible (${triggerSource})`
      );
      return;
    }
    const activeModal = document.querySelector('.modal[aria-hidden="false"]');
    if (activeModal && activeModal !== modal) return;
    currentGender = gender;
    console.info(
      `%c[SizeChart] Opened (${gender}) via ${triggerSource}`,
      "color: #00c853; font-weight: 600;"
    );
    openModal();
  }

  document.addEventListener("click", (e) => {
  const anchor = e.target.closest('a');
  const label  = anchor?.getAttribute('aria-label')?.toLowerCase() || '';
  const isSizeLink = label.includes('size');

  const opener = e.target.closest('[data-open-sizeguide],[data-open-custom-sizechart],.custom-sizechart-link');
  if (!isSizeLink && !opener) return;

  console.log('Size chart link clicked');
  e.preventDefault();
  if (isSizeLink) {
    anchor.setAttribute('href', '#sizeChartModal');
    //window.location.hash = '#sizeChartModal';
  }
  setTimeout(() => {
    const mode = window.location.hash.toLowerCase() === '#sizechartmodal'
      ? 'click-hash'
      : 'click-direct';
    tryOpenSizeChart(mode);
  }, 150);
});

  window.addEventListener("load", () => {
    if (window.location.hash.toLowerCase() === "#sizechartmodal") {
      setTimeout(() => tryOpenSizeChart("auto-hash"), 400);
    }
  });

  function clearHash() {
    if (window.location.hash === "#sizeChartModal") {
      history.replaceState(null, "", window.location.pathname);
    }
  }
  modal?.addEventListener("transitionend", clearHash);

  (function initUnits() {
    $$(".unit-button", modal).forEach((b) =>
      b.classList.toggle("active", b.dataset.unit === currentUnit)
    );
  })();

  function initScrollbar(wrapper) {
    let scrollInner = wrapper.querySelector(".table-scroll-inner");
    if (!scrollInner) {
      scrollInner = document.createElement("div");
      scrollInner.className = "table-scroll-inner";
      while (wrapper.firstChild) scrollInner.appendChild(wrapper.firstChild);
      wrapper.appendChild(scrollInner);
      wrapper.insertAdjacentHTML(
        "beforeend",
        `<div class="size-chart-scrollbar"><div class="size-chart-scrollbar-thumb"></div></div>`
      );
    }
    const scrollbar = wrapper.querySelector(".size-chart-scrollbar");
    const thumb = scrollbar.querySelector(".size-chart-scrollbar-thumb");

    function updateThumb() {
      const visible = scrollInner.clientWidth;
      const total = scrollInner.scrollWidth;
      const left = scrollInner.scrollLeft;
      if (total <= visible) return (scrollbar.style.display = "none");
      scrollbar.style.display = "block";
      const ratio = visible / total;
      const tw = Math.max(visible * ratio, 40);
      const maxLeft = scrollbar.clientWidth - tw;
      const l = (left / (total - visible)) * maxLeft;
      thumb.style.width = tw + "px";
      thumb.style.left = l + "px";
    }

    scrollInner.addEventListener("scroll", updateThumb);
    window.addEventListener("resize", updateThumb);
    updateThumb();

    let isDragging = false,
      startX,
      startLeft;

    thumb.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.clientX;
      startLeft = parseInt(thumb.style.left) || 0;
      document.body.style.userSelect = "none";
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      const dx = e.clientX - startX;
      const newLeft = Math.min(
        Math.max(startLeft + dx, 0),
        scrollbar.clientWidth - thumb.offsetWidth
      );
      thumb.style.left = newLeft + "px";
      const scrollRatio = newLeft / (scrollbar.clientWidth - thumb.offsetWidth);
      scrollInner.scrollLeft =
        scrollRatio * (scrollInner.scrollWidth - scrollInner.clientWidth);
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;
      document.body.style.userSelect = "";
    });

    thumb.addEventListener("touchstart", (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
      startLeft = parseInt(thumb.style.left) || 0;
    });

    document.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      const dx = e.touches[0].clientX - startX;
      const newLeft = Math.min(
        Math.max(startLeft + dx, 0),
        scrollbar.clientWidth - thumb.offsetWidth
      );
      thumb.style.left = newLeft + "px";
      const scrollRatio = newLeft / (scrollbar.clientWidth - thumb.offsetWidth);
      scrollInner.scrollLeft =
        scrollRatio * (scrollInner.scrollWidth - scrollInner.clientWidth);
    });

    document.addEventListener("touchend", () => {
      isDragging = false;
    });
  }
})();